// extracted by mini-css-extract-plugin
export var blue = "_30-h";
export var brand = "_30-d";
export var darkGrey = "_30-g";
export var disabled = "_30-6";
export var disabledSubtle = "_30-7";
export var error = "_30-8";
export var green = "_30-i";
export var grey = "_30-f";
export var icon = "_30-0";
export var inherit = "_30-c";
export var lightGrey = "_30-e";
export var orange = "_30-k";
export var pink = "_30-m";
export var primary = "_30-1";
export var purple = "_30-n";
export var quaternary = "_30-4";
export var quinary = "_30-5";
export var red = "_30-l";
export var secondary = "_30-2";
export var success = "_30-b";
export var tertiary = "_30-3";
export var warning = "_30-9";
export var warningSecondary = "_30-a";
export var white = "_30-o";
export var yellow = "_30-j";